import React from 'react';
import { Group } from '../../../containers';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { Blanket } from '../../feedback/Blanket';
import { Box } from '../Box'; // TODO: remove OnRowClickParam type definition & update _TableMobileContainerProps type definition
// ticket - ME-36903 - https://meliorisk.atlassian.net/browse/ME-36903
// eslint-disable-next-line @typescript-eslint/naming-convention

import { jsx as _jsx } from "react/jsx-runtime";
export var _TableMobileContainer = _ref => {
  var {
    getRowModel,
    onRowClick,
    highlightedRowIds,
    isLoading,
    mobileRowRenderer,
    getRowAriaLabel
  } = _ref;
  var style = useMultiStyleConfig('TableMobileContainer', {});

  var handleKeyDown = (event, rowId, rowData) => {
    if (!onRowClick) {
      return;
    }

    if ([' ', 'Enter'].includes(event.key)) {
      event.preventDefault();
      onRowClick({
        rowId,
        rowData
      });
    }
  };

  return /*#__PURE__*/_jsx(Box, {
    __css: style['container'],
    children: isLoading ? /*#__PURE__*/_jsx(Box, {
      __css: style['loaderContainer'],
      children: /*#__PURE__*/_jsx(Blanket, {
        isOpen: true,
        variant: "light",
        isLoading: true
      })
    }) : /*#__PURE__*/_jsx(Group, {
      variant: "vertical",
      spacing: "none",
      hasDivider: true,
      children: getRowModel().rows.map(row => {
        var {
          id,
          original: rowData
        } = row;
        var isRowHighlighted = highlightedRowIds === null || highlightedRowIds === void 0 ? void 0 : highlightedRowIds.includes(id);
        return /*#__PURE__*/_jsx(Box, {
          role: onRowClick && 'button',
          "data-highlighted": isRowHighlighted || null,
          __css: style['row'],
          onClick: onRowClick ? () => onRowClick({
            rowId: id,
            rowData
          }) : undefined,
          onKeyDown: event => handleKeyDown(event, id, rowData),
          tabIndex: onRowClick ? 0 : -1,
          "aria-label": getRowAriaLabel === null || getRowAriaLabel === void 0 ? void 0 : getRowAriaLabel({
            rowId: row.id,
            rowData: row.original
          }),
          children: mobileRowRenderer(rowData)
        }, id);
      })
    })
  });
};
_TableMobileContainer.displayName = '_TableMobileContainer';
//# sourceMappingURL=_TableMobileContainer.js.map